export const partnerDetailsUpdatesSchema = [
  {
    title: 'Company name',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'name',
    updated: false,
    submitted: false
  },
  {
    title: 'Company ABN',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'abn',
    updated: false,
    submitted: false
  },
  {
    title: 'Address',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'address',
    updated: false,
    submitted: false
  },
  {
    title: 'Website',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'website',
    updated: false,
    submitted: false
  },
  {
    title: 'Primary contact',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'primaryContact',
    updated: false,
    submitted: false
  },
  {
    title: 'Phone (work)',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'phoneWork',
    updated: false,
    submitted: false
  },
  {
    title: 'Phone (mobile)',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'phoneMobile',
    updated: false,
    submitted: false
  },
  {
    title: 'Email (primary)',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'emailPrimary',
    updated: false,
    submitted: false
  },
  {
    title: 'Email (alternative)',
    section: 'company',
    sectionTitle: 'Company details',
    field: 'emailAlternative',
    updated: false,
    submitted: false
  },
  {
    title: 'Information about the business',
    section: 'general',
    sectionTitle: 'General information',
    field: 'aboutBusiness',
    updated: false,
    submitted: false
  },
  {
    title: 'Annual revenue',
    section: 'general',
    sectionTitle: 'General information',
    field: 'annualRevenue',
    updated: false,
    submitted: false
  },
  {
    title: 'Number of customers',
    section: 'general',
    sectionTitle: 'General information',
    field: 'numberOfCustomers',
    updated: false,
    submitted: false
  },
  {
    title: 'Areas where the most of customers are located',
    section: 'general',
    sectionTitle: 'General information',
    field: 'customerAreas',
    updated: false,
    submitted: false
  },
  {
    title: 'Other relevant information',
    section: 'general',
    sectionTitle: 'General information',
    field: 'other',
    updated: false,
    submitted: false
  },
  {
    title: 'Technical information',
    section: 'technic',
    sectionTitle: 'Technical information',
    field: 'info',
    updated: false,
    submitted: false
  },
  {
    title: 'Technical contact',
    section: 'technic',
    sectionTitle: 'Technical information',
    field: 'contact',
    updated: false,
    submitted: false
  },
  {
    title: 'Phone (work)',
    section: 'technic',
    sectionTitle: 'Technical information',
    field: 'phoneWork',
    updated: false,
    submitted: false
  },
  {
    title: 'Phone (mobile)',
    section: 'technic',
    sectionTitle: 'Technical information',
    field: 'phoneMobile',
    updated: false,
    submitted: false
  },
  {
    title: 'Email (primary)',
    section: 'technic',
    sectionTitle: 'Technical information',
    field: 'emailPrimary',
    updated: false,
    submitted: false
  },
  {
    title: 'Email (alternative)',
    section: 'technic',
    sectionTitle: 'Technical information',
    field: 'emailAlternative',
    updated: false,
    submitted: false
  }
]
